import baseurl from "../Api/BaseUrl"

const deleteData = async (url, params) => {
    const res = await baseurl.delete(url, params)
    return res.data
}

export default deleteData;
